import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { OfferStockVehicleDataPathParams } from "./OfferStockVehicleDataPathParams"
import type { OfferVehicleDataView } from "./OfferVehicleDataView"

export const getVehicleDataForStockOfferRoute: ApiRoute<
	OfferStockVehicleDataPathParams,
	NoQueryParams,
	NoBody,
	OfferVehicleDataView
> = {
	buildUrl: ({ vehicleId }) => `/offers/vehicle-data/stock/${vehicleId}`,
	method: "get",
	path: "/offers/vehicle-data/stock/:vehicleId",
}
